<template>
  <v-app id="inspire" v-if="!isPasswordTokenValidLoading">
    <v-snackbar v-model="flag" top color="error" v-if="!validReset">
      {{ message }}
      <v-btn color="white" text @click="flag = false">Close</v-btn
      ></v-snackbar>

    <v-layout row wrap>
      <v-flex sm12 md6>
        <v-img src="../assets/logo-B.jpg" :aspect-ratio="1"></v-img>
        <p class="text-center">Climate RX v.1.20.2022</p>
      </v-flex>
      <v-flex sm12 md6 id="reset-password-card">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="9">
            <v-card class="elevation-12">

              <template v-if="isPasswordTokenValid">
                <v-toolbar dark flat>
                  <v-toolbar-title>RESET PASSWORD</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-else>
                <v-toolbar color="red darken-4" flat>
                  <v-icon large color="yellow darken-5">
                    mdi-timer-off
                  </v-icon>
                  <v-toolbar-title class="white--text ml-4">LINK HAS EXPIRED</v-toolbar-title>
                </v-toolbar>
              </template>

              <template v-if="validReset">
                <v-card-text class="px-4 py-4">
                  <v-icon large color="green darken-2">
                    mdi-check
                  </v-icon>
                  <h2 class="d-inline-block align-sub ml-4 mb-4">Success!</h2>
                  <p>Your password has been updated. Use your new password to log in.</p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="white--text mr-2"
                    color="#2b3990"
                    href="/"
                  >
                    Continue
                  </v-btn>
                </v-card-actions>
              </template>
              <template v-else>

                <template v-if="isPasswordTokenValid">
                  <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <label>Password</label>
                      <v-text-field
                        name="password"
                        required
                        v-model="password"
                        :rules="passwordRules"
                        prepend-icon="mdi-lock"
                        type="password"
                        v-on:keydown.enter.prevent="onEnterKey"
                      ></v-text-field>
                      <label>Re-type Password</label>
                      <v-text-field
                        name="password-confirm"
                        required
                        v-model="passwordConfirm"
                        :rules="[(password === passwordConfirm) || 'Password doesn\'t match']"
                        prepend-icon="mdi-lock-outline"
                        type="password"
                        v-on:keydown.enter.prevent="onEnterKey"
                      ></v-text-field>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="white--text mr-2"
                      color="#2b3990"
                      @click="sendChangePasswordInstructions"
                    >
                      Reset<Loader v-if="loading" />
                    </v-btn>
                  </v-card-actions>
                </template>
                <template v-else>
                  <v-card-text class="px-4 py-4">
                    <p>{{ isPasswordTokenValidMsg }}</p>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="white--text mr-2"
                      color="#2b3990"
                      href="/"
                    >
                      Continue
                    </v-btn>
                  </v-card-actions>
                </template>

              </template>

            </v-card>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
  import { mapActions } from "vuex";
  import Loader from "@/components/Spinner.vue";
  import axios from "axios";

  const url = require("../client_config/config").url;

  export default {
    name: "ResetPassword",
    components: { Loader },
    data() {
      return {
        valid: true,
        loading: false,
        flag: false,
        password: "",
        passwordConfirm: "",
        message: "",
        validReset: false,
        passwordRules: [
          (v) => !!v || "Password is required",
          (v) => (v && v.length >= 6 ) || 'Password should be a minimum of 6 characters',
          (v) => (v && /\d/.test(v)) || 'Password should have at least one digit',
          (v) => (v && /[A-Z]{1}/.test(v)) || 'Password should have at least one capital latter',
          (v) => (v && /[^A-Za-z0-9]/.test(v)) || 'Password should have at least one special character',
        ],
        resetPasswordToken: this.$route.params.token,
        isPasswordTokenValid: false,
        isPasswordTokenValidMsg: "",
        isPasswordTokenValidLoading: true,
      }
    },
    created() {
      this.passwordTokenValidity();
    },
    methods: {
      ...mapActions(["updatePassword"]),

      validate() {
        return this.$refs.form.validate();
      },

      onEnterKey: function(e) {
        if (e.keyCode === 13) {
          this.sendChangePasswordInstructions();
        }
      },

      sendChangePasswordInstructions() {
        this.loading = true;

        if (this.validate()) {
          let reqBody = { token: this.resetPasswordToken, password: this.password }

          this.updatePassword(reqBody)
            .then((res) => {
              if (!res.data.success) {
                this.flag = true;
                this.loading = false;
                this.message = res.data.msg;

                return;
              } else {
                this.loading = false;
                this.validReset = true;
                this.message = res.data.msg;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.loading = false;
        }
      },

      passwordTokenValidity() {
        axios.get(`${url}/users/reset-password/${this.resetPasswordToken}`).then(res => {
          this.isPasswordTokenValid = res.data.success;
          this.isPasswordTokenValidMsg = res.data.msg;
          this.isPasswordTokenValidLoading = false;
        });
      }
    }
  }
</script>
<style scoped>
  #reset-password-card {
    margin-top: auto;
    margin-bottom: auto;
  }

  .align-sub {
    vertical-align: sub;
  }

  @media only screen and (max-width: 480px) {
    #reset-password-card {
      margin-top: -40px;
      padding-top: 0;
      margin-right: 25px;
      margin-left: 25px;
    }
  }
</style>